import emailjs from "@emailjs/browser";
import React, { useRef } from "react";
import { toast } from "react-toastify";

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0ru86jr",
        "template_asbbx92",
        form.current,
        "S62QiZ0e98YJ0RK_h"
      )
      .then(
        (result) => {
          toast("Congratulation Your Message Has been Sent");
        },
        (error) => {
          toast.error("Not send Try Again! ");
        }
      );
    e.target.reset();
  };
  return (
    <div id="contact" className="max-w-[1100px] mx-auto px-2 my-8 lg:my-20">
      <div className="grid grid-cols-1 px-4">
        <div className="title">
          <h2 className="lg:text-6xl text-4xl text-primary font-bold tracking-widest   title-project">
            Get In Touch
          </h2>
        </div>
        <form ref={form} onSubmit={sendEmail} className="my-12 w-[100%]">
          <div className="name w-[100%] mb-4">
            <label htmlFor="name" className="block text-xl ">
              Your Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Type Where"
              required
              id="name"
              className="border-2 outline-0 border-primary py-2 px-4 rounded w-[100%] bg-transparent"
            />
          </div>
          <div className="name w-[100%] mb-4">
            <label htmlFor="name" className="block text-xl ">
              Your Email
            </label>
            <input
              type="email"
              required
              name="email"
              placeholder="Type Where"
              id="email"
              className="border-2 outline-0 border-primary py-2 px-4 rounded w-[100%] bg-transparent"
            />
          </div>
          <div className="name w-[100%] mb-4">
            <label htmlFor="message" className="block text-xl ">
              Message
            </label>
            <textarea
              name="message"
              required
              id="message"
              placeholder="Type Where"
              cols="30"
              className="border-2 outline-0 border-primary py-2 px-4 rounded w-[100%] bg-transparent"
              rows="10"
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary px-6">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
